import React from "react";
import PaymentDetail from "../../common/PaymentDetail";

const BuyWifiSummary = ({ detail }) => {
  return (
    <>
      <PaymentDetail
        title="Account/Mobile Number:"
        value={detail["Account/Mobile Number"]}
      />
      <PaymentDetail title="Telco:" value={detail.telco} />
      <PaymentDetail title="Available Products:" value={detail.product} />
      <PaymentDetail title="Amount:" value={"P" + detail.amount} />
      <PaymentDetail
        title="Discount"
        value={"P" + detail.discount.toFixed(2)}
      />
      <PaymentDetail
        title="Net Total"
        value={"P" + (detail.amount - detail.discount)}
      />
    </>
  );
};

export default BuyWifiSummary;
